// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"Page_pageWrapper__yH3qv","pageWithHomeHeader":"Page_pageWithHomeHeader__0Hjrk"};